import React from 'react';

import CircleIconButton from '../../Default/CircleIconButton';
import { SideBarItems } from '../../../shared';
import settings from '../../../../settings';

const Nav = ({ activeBlockUrl, activeItem, handleSelectColor, handleSelectDraw, handleSelectErase }) => {
    return (
        <div className="side-bar-row side-bar-top-nav">
            <div className="side-bar-nav-item">
                <CircleIconButton
                    active={activeItem === SideBarItems.BACKGROUND_COLOR}
                    onClick={handleSelectColor}
                    src={`${settings.assetsPath}img/icons/color_buckit.png`}
                    style={{ width: '3rem', height: '3rem' }}
                    iconStyle={{ width: '2rem', height: '2rem', margin: '0.5rem' }}
                />
            </div>
            <div className="side-bar-nav-item">
                <CircleIconButton
                    active={activeItem === SideBarItems.BACKGROUND_DRAW}
                    onClick={handleSelectDraw}
                    src={`${settings.assetsPath}img/icons/kwast.png`}
                    backgroundSrc={activeBlockUrl}
                    style={{ width: '3rem', height: '3rem' }}
                    iconStyle={{ width: '2rem', height: '2rem', margin: '0.5rem' }}
                />
            </div>
            <div className="side-bar-nav-item">
                <CircleIconButton
                    active={activeItem === SideBarItems.BACKGROUND_ERASE}
                    onClick={handleSelectErase}
                    src={`${settings.assetsPath}img/icons/eraser.png`}
                    style={{ width: '3rem', height: '3rem' }}
                    iconStyle={{ width: '2rem', height: '2rem', margin: '0.5rem' }}
                />
            </div>
        </div>
    );
};

export default Nav;
